/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTrashDrop: {
  name: 'trash-drop';
  data: string;
} = {
  name: 'trash-drop',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1.5h-3V2Zm-1 1.5H1a.5.5 0 0 0 0 1h1.5V14A1.5 1.5 0 0 0 4 15.5h6a.5.5 0 0 0 0-1H4a.5.5 0 0 1-.5-.5V4.5h9V10a.5.5 0 0 0 1 0V4.5H15a.5.5 0 0 0 0-1h-4.5V2A1.5 1.5 0 0 0 9 .5H7A1.5 1.5 0 0 0 5.5 2v1.5Zm5 4.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0V8ZM6 7.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5Zm6.5 7.5L10 12h5l-2.5 3Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
